export default __webpack_public_path__ + "static/media/Read-Light_V1100.150c5859.woff";